<template>
	<div>
		<header>
			<h1>Job Monitor</h1>
		</header>
		<div>
			<div v-if="!loaded" class="section">
				<loader/>
			</div>
			<template v-else>
				<div class="sections sections--flexed">
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Last Job Pushed To Queue </span>
							<span
								class="metrics__metric__stats__value" data-metric-number
								v-html="$present('dateTime', stats.timeLastJobPushedToQueue)"/>
						</p>
					</section>
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Last Job Processed on Queue </span>
							<span
								class="metrics__metric__stats__value" data-metric-number
								v-html="$present('dateTime', stats.timeLastJobProcessedOnQueue)"/>
						</p>
					</section>
					<section class="section metrics__metric--number">
						<p class="metrics__metric__stats">
							<span class="metrics__metric__stats__title">Queue Running OK </span>
							<bool-icon :value="stats.ok" class="metrics__metric__stats__value"/>
						</p>
					</section>
				</div>
				<div class="section">
					<!--					<table-filter :filters="filters"/>-->
					<div v-if="!items.length" class="nothing-to-see-here">
						<p>Nothing to display.</p>
					</div>
					<v-table v-if="items.length" :loading="gettingModels">
						<thead>
							<tr>
								<th align="left">Name</th>
								<th align="left">Queued</th>
								<th align="center">Attempts</th>
								<th align="center">Reserved</th>
								<th align="center">Processed</th>
								<th align="center">Failed</th>
							</tr>
						</thead>
						<tfoot>
							<tr>
								<th align="left">Name</th>
								<th align="left">Queued</th>
								<th align="center">Attempts</th>
								<th align="center">Reserved</th>
								<th align="center">Processed</th>
								<th align="center">Failed</th>
							</tr>
						</tfoot>
						<tbody>
							<tr v-for="(item, itemIndex) in items" :key="itemIndex">
								<td v-html="item.name"/>
								<td v-html="$present('dateTime', item.created_at)"/>
								<td align="center" v-html="item.attempts"/>
								<td align="center">
									<bool-icon :value="item.reserved_at"/>
								</td>
								<td align="center">
									<bool-icon :value="item.processed_at"/>
								</td>
								<td align="center">
									<bool-icon :value="item.failed_at"/>
								</td>
							</tr>
						</tbody>
					</v-table>
					<paginator :links="links" :meta="meta"/>
				</div>
			</template>
		</div>
	</div>
</template>
<script>
import Index from "../../../../components";

let index = new Index("jobs");

export default {
	computed: {
		...index.computed(),
	},

	methods: {
		...index.actions(),
	},

	created() {
		this.filter(this.$router.currentRoute.query);
	},
};
</script>
